import { useState as e } from "/home/runner/work/oko-web/oko-web/node_modules/react/index.js";
//#region src/lib/hooks/useNaturalSort.ts
var t = (t) => {
	let [n] = e(new Intl.Collator(void 0, {
		numeric: !0,
		sensitivity: "base"
	}));
	return (e, r) => n.compare(t(e), t(r));
}, n = (e, n) => {
	let r = t(n);
	return e.slice().sort(r);
};
//#endregion
export { n as useNaturalSort, t as useNaturalSortFn };
